import axiosClient from "./axiosClient";
const LOCAL_STORAGE_USER = 'USER_LOCAL'
const userApi = {
    createUserCustomer: (data) =>{
        const url = `api/user/createUserCustomer`
        const body = {
            ...data,
            platform: 'web'
        }
        return axiosClient.post(url,body)
    },
    
    getUserById: (id) =>{
        const url = `api/user/${id}`
        return axiosClient.get(url)
    },
    getAllUser: (body) =>{
        const url = `api/user/getall`
        return axiosClient.post(url, body, {
            useAuthorize: true
        })
    },    
    update: (data) =>{
        const url = `api/user/update`
        const body = {
            ...data,
            platform: 'web'
        }
        return axiosClient.post(url, body)
    },
    clearUserLocalStorage: () => {
        localStorage.removeItem(LOCAL_STORAGE_USER)
    },
    setUserLocalStorage: (data) => {
        try{
            localStorage.setItem(LOCAL_STORAGE_USER, JSON.stringify(data))
        }catch(e){
            console.log('setUserLocalStorage err : ' + e)
        }        
    },
    getUserLocal: () => {
        let userLocal = null 
        try{
            const data = localStorage.getItem(LOCAL_STORAGE_USER)
            userLocal = data ? JSON.parse(data) : null
        }catch(e){
            console.log('getUserLocal err : ' + e)
        }          
        return userLocal
    },
    userReadyLogin : () => {
        const user = userApi.getUserLocal()
        const isReady = (user?.id != null &&  user?.id != '') ? true : false
        return isReady;
    }
    
}
export default userApi;